// The admin inbox, client side (spec 2026-10-24). The RPCs refuse anyone but
// an admin and never return the caller's own commands; this layer only calls
// them and re-validates what comes back.
import type { SupabaseClient } from '@supabase/supabase-js';
import { parseCommandLog, type CommandLogRow } from '../config/devCommandLog';

type Result<T> = { ok: true; value: T } | { ok: false; error: string };

/** Newest first; `messagesOnly` is the MESSAGES toggle. */
export async function listCommandLog(
  c: SupabaseClient,
  messagesOnly: boolean,
): Promise<Result<CommandLogRow[]>> {
  const { data, error } = await c.rpc('admin_list_command_log', {
    messages_only: messagesOnly,
    max_rows: 200,
  });
  if (error) return { ok: false, error: error.message };
  return { ok: true, value: parseCommandLog(data) };
}

/** Commands logged since this admin last opened the inbox (0 on any error). */
export async function inboxUnread(c: SupabaseClient): Promise<number> {
  const { data, error } = await c.rpc('admin_inbox_unread');
  if (error || typeof data !== 'number') return 0;
  return data;
}

/** Opening the inbox clears the red "!" (kept server-side, so on every device). */
export async function markInboxSeen(c: SupabaseClient): Promise<void> {
  await c.rpc('admin_inbox_mark_seen');
}
